import { ChangeAlertCallbackType } from "../components/Root";
import { getPosition } from "./PositionService";
import * as API from '../http/api';

export class IngressService {
    private changeAlert: ChangeAlertCallbackType
    constructor(changeAlert: ChangeAlertCallbackType) {
        this.changeAlert = changeAlert
    }

    async companyList(data) {
        const pos = getPosition();
        const response = await API.service('companyList', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async companyInsert(data) {
        const pos = getPosition();
        const response = await API.service('companyInsert', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async companyUpdate(data) {
        const pos = getPosition();
        const response = await API.service('companyUpdate', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async companyDelete(data) {
        const pos = getPosition();
        const response = await API.service('companyDelete', data, pos, this.changeAlert, null, null);

        return response?.data
    }

}